"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _constants = require("@gravity/theme-provider/lib/constants");
var _ProductHelper = _interopRequireDefault(require("./ProductHelper"));
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductActions.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_22agp4srev() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductActions.js";
  var hash = "09ee7604592e6ed59e5f272eb7a35c2e6d5d2cce";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductActions.js",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 71,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 34
        },
        end: {
          line: 24,
          column: 86
        }
      },
      "2": {
        start: {
          line: 37,
          column: 34
        },
        end: {
          line: 37,
          column: 65
        }
      },
      "3": {
        start: {
          line: 54,
          column: 34
        },
        end: {
          line: 54,
          column: 65
        }
      },
      "4": {
        start: {
          line: 73,
          column: 21
        },
        end: {
          line: 110,
          column: 2
        }
      },
      "5": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 90,
          column: 7
        }
      },
      "6": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 88
        }
      },
      "7": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 98,
          column: 9
        }
      },
      "8": {
        start: {
          line: 112,
          column: 19
        },
        end: {
          line: 119,
          column: 1
        }
      },
      "9": {
        start: {
          line: 115,
          column: 26
        },
        end: {
          line: 115,
          column: 60
        }
      },
      "10": {
        start: {
          line: 116,
          column: 29
        },
        end: {
          line: 116,
          column: 57
        }
      },
      "11": {
        start: {
          line: 117,
          column: 27
        },
        end: {
          line: 117,
          column: 55
        }
      },
      "12": {
        start: {
          line: 118,
          column: 28
        },
        end: {
          line: 118,
          column: 56
        }
      },
      "13": {
        start: {
          line: 121,
          column: 20
        },
        end: {
          line: 126,
          column: 1
        }
      },
      "14": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 31
        }
      },
      "15": {
        start: {
          line: 147,
          column: 16
        },
        end: {
          line: 147,
          column: 80
        }
      },
      "16": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 153,
          column: 31
        }
      },
      "17": {
        start: {
          line: 154,
          column: 29
        },
        end: {
          line: 154,
          column: 88
        }
      },
      "18": {
        start: {
          line: 154,
          column: 36
        },
        end: {
          line: 154,
          column: 88
        }
      },
      "19": {
        start: {
          line: 156,
          column: 2
        },
        end: {
          line: 184,
          column: 4
        }
      },
      "20": {
        start: {
          line: 164,
          column: 10
        },
        end: {
          line: 180,
          column: 11
        }
      },
      "21": {
        start: {
          line: 187,
          column: 0
        },
        end: {
          line: 211,
          column: 2
        }
      },
      "22": {
        start: {
          line: 213,
          column: 0
        },
        end: {
          line: 228,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 15
          },
          end: {
            line: 24,
            column: 16
          }
        },
        loc: {
          start: {
            line: 24,
            column: 34
          },
          end: {
            line: 24,
            column: 86
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 37,
            column: 25
          }
        },
        loc: {
          start: {
            line: 37,
            column: 34
          },
          end: {
            line: 37,
            column: 65
          }
        },
        line: 37
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 24
          },
          end: {
            line: 54,
            column: 25
          }
        },
        loc: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 65
          }
        },
        line: 54
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 83,
            column: 24
          },
          end: {
            line: 83,
            column: 25
          }
        },
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 90,
            column: 7
          }
        },
        line: 84
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 91,
            column: 22
          },
          end: {
            line: 91,
            column: 23
          }
        },
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 88
          }
        },
        line: 92
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 94,
            column: 26
          },
          end: {
            line: 94,
            column: 27
          }
        },
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        line: 95
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 115,
            column: 16
          },
          end: {
            line: 115,
            column: 17
          }
        },
        loc: {
          start: {
            line: 115,
            column: 26
          },
          end: {
            line: 115,
            column: 60
          }
        },
        line: 115
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 116,
            column: 19
          },
          end: {
            line: 116,
            column: 20
          }
        },
        loc: {
          start: {
            line: 116,
            column: 29
          },
          end: {
            line: 116,
            column: 57
          }
        },
        line: 116
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 117,
            column: 17
          },
          end: {
            line: 117,
            column: 18
          }
        },
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 117,
            column: 55
          }
        },
        line: 117
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 118,
            column: 18
          },
          end: {
            line: 118,
            column: 19
          }
        },
        loc: {
          start: {
            line: 118,
            column: 28
          },
          end: {
            line: 118,
            column: 56
          }
        },
        line: 118
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 122,
            column: 12
          }
        },
        loc: {
          start: {
            line: 122,
            column: 20
          },
          end: {
            line: 122,
            column: 31
          }
        },
        line: 122
      },
      "11": {
        name: "ProductActions",
        decl: {
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 131,
            column: 23
          }
        },
        loc: {
          start: {
            line: 146,
            column: 3
          },
          end: {
            line: 185,
            column: 1
          }
        },
        line: 146
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 154,
            column: 29
          },
          end: {
            line: 154,
            column: 30
          }
        },
        loc: {
          start: {
            line: 154,
            column: 36
          },
          end: {
            line: 154,
            column: 88
          }
        },
        line: 154
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 163,
            column: 8
          },
          end: {
            line: 163,
            column: 9
          }
        },
        loc: {
          start: {
            line: 164,
            column: 10
          },
          end: {
            line: 180,
            column: 11
          }
        },
        line: 164
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 37,
            column: 34
          },
          end: {
            line: 37,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 49
          },
          end: {
            line: 37,
            column: 54
          }
        }, {
          start: {
            line: 37,
            column: 57
          },
          end: {
            line: 37,
            column: 65
          }
        }],
        line: 37
      },
      "1": {
        loc: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 49
          },
          end: {
            line: 54,
            column: 54
          }
        }, {
          start: {
            line: 54,
            column: 57
          },
          end: {
            line: 54,
            column: 65
          }
        }],
        line: 54
      },
      "2": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 37
          },
          end: {
            line: 85,
            column: 40
          }
        }, {
          start: {
            line: 85,
            column: 43
          },
          end: {
            line: 85,
            column: 44
          }
        }],
        line: 85
      },
      "3": {
        loc: {
          start: {
            line: 87,
            column: 10
          },
          end: {
            line: 87,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 39
          },
          end: {
            line: 87,
            column: 42
          }
        }, {
          start: {
            line: 87,
            column: 45
          },
          end: {
            line: 87,
            column: 46
          }
        }],
        line: 87
      },
      "4": {
        loc: {
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 10
          },
          end: {
            line: 88,
            column: 28
          }
        }, {
          start: {
            line: 88,
            column: 32
          },
          end: {
            line: 88,
            column: 66
          }
        }],
        line: 88
      },
      "5": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 72
          },
          end: {
            line: 92,
            column: 83
          }
        }, {
          start: {
            line: 92,
            column: 86
          },
          end: {
            line: 92,
            column: 88
          }
        }],
        line: 92
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 36
          }
        }, {
          start: {
            line: 92,
            column: 40
          },
          end: {
            line: 92,
            column: 69
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 96,
            column: 46
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 39
          },
          end: {
            line: 96,
            column: 42
          }
        }, {
          start: {
            line: 96,
            column: 45
          },
          end: {
            line: 96,
            column: 46
          }
        }],
        line: 96
      },
      "8": {
        loc: {
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 97,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 10
          },
          end: {
            line: 97,
            column: 28
          }
        }, {
          start: {
            line: 97,
            column: 32
          },
          end: {
            line: 97,
            column: 66
          }
        }],
        line: 97
      },
      "9": {
        loc: {
          start: {
            line: 115,
            column: 26
          },
          end: {
            line: 115,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 41
          },
          end: {
            line: 115,
            column: 51
          }
        }, {
          start: {
            line: 115,
            column: 54
          },
          end: {
            line: 115,
            column: 60
          }
        }],
        line: 115
      },
      "10": {
        loc: {
          start: {
            line: 116,
            column: 29
          },
          end: {
            line: 116,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 44
          },
          end: {
            line: 116,
            column: 49
          }
        }, {
          start: {
            line: 116,
            column: 52
          },
          end: {
            line: 116,
            column: 57
          }
        }],
        line: 116
      },
      "11": {
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 117,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 42
          },
          end: {
            line: 117,
            column: 47
          }
        }, {
          start: {
            line: 117,
            column: 50
          },
          end: {
            line: 117,
            column: 55
          }
        }],
        line: 117
      },
      "12": {
        loc: {
          start: {
            line: 118,
            column: 28
          },
          end: {
            line: 118,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 43
          },
          end: {
            line: 118,
            column: 48
          }
        }, {
          start: {
            line: 118,
            column: 51
          },
          end: {
            line: 118,
            column: 56
          }
        }],
        line: 118
      },
      "13": {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 153,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 150,
            column: 11
          }
        }, {
          start: {
            line: 151,
            column: 5
          },
          end: {
            line: 151,
            column: 16
          }
        }, {
          start: {
            line: 151,
            column: 20
          },
          end: {
            line: 151,
            column: 38
          }
        }, {
          start: {
            line: 152,
            column: 5
          },
          end: {
            line: 152,
            column: 13
          }
        }, {
          start: {
            line: 152,
            column: 17
          },
          end: {
            line: 152,
            column: 32
          }
        }, {
          start: {
            line: 153,
            column: 5
          },
          end: {
            line: 153,
            column: 12
          }
        }, {
          start: {
            line: 153,
            column: 16
          },
          end: {
            line: 153,
            column: 30
          }
        }],
        line: 150
      },
      "14": {
        loc: {
          start: {
            line: 164,
            column: 10
          },
          end: {
            line: 180,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 10
          },
          end: {
            line: 164,
            column: 25
          }
        }, {
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 179,
            column: 25
          }
        }],
        line: 164
      },
      "15": {
        loc: {
          start: {
            line: 167,
            column: 26
          },
          end: {
            line: 167,
            column: 127
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 88
          },
          end: {
            line: 167,
            column: 111
          }
        }, {
          start: {
            line: 167,
            column: 114
          },
          end: {
            line: 167,
            column: 127
          }
        }],
        line: 167
      },
      "16": {
        loc: {
          start: {
            line: 167,
            column: 26
          },
          end: {
            line: 167,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 26
          },
          end: {
            line: 167,
            column: 68
          }
        }, {
          start: {
            line: 167,
            column: 72
          },
          end: {
            line: 167,
            column: 85
          }
        }],
        line: 167
      },
      "17": {
        loc: {
          start: {
            line: 173,
            column: 18
          },
          end: {
            line: 175,
            column: 24
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 22
          },
          end: {
            line: 174,
            column: 78
          }
        }, {
          start: {
            line: 175,
            column: 22
          },
          end: {
            line: 175,
            column: 24
          }
        }],
        line: 173
      },
      "18": {
        loc: {
          start: {
            line: 182,
            column: 7
          },
          end: {
            line: 182,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 7
          },
          end: {
            line: 182,
            column: 17
          }
        }, {
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 78
          }
        }],
        line: 182
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0, 0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "09ee7604592e6ed59e5f272eb7a35c2e6d5d2cce"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22agp4srev = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22agp4srev();
var Wrapper = (cov_22agp4srev().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: function className(_ref) {
    var productId = _ref.productId;
    cov_22agp4srev().f[0]++;
    cov_22agp4srev().s[1]++;
    return "stx-ProductActions stx-ProductActions-".concat(productId);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _constants.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-grow: 0;\n      justify-content: center;\n      flex-wrap: wrap;\n      padding-top: 0.5rem;\n      padding-bottom: 0.5rem;\n      position: relative; /* to avoid to be part of clickable zone*/\n      z-index: 2; /* to avoid to be part of clickable zone*/\n      float: right;\n      flex-direction: ", ";\n      @media screen and (max-width: 40em) {\n        float: unset;\n      }\n      width: 100%;\n    "])), function (props) {
  cov_22agp4srev().f[1]++;
  cov_22agp4srev().s[2]++;
  return props.inline ? (cov_22agp4srev().b[0][0]++, 'row') : (cov_22agp4srev().b[0][1]++, 'column');
})), _constants.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      flex-grow: 0;\n      justify-content: center;\n      flex-wrap: wrap;\n      flex-direction: column;\n      padding: 24px 0;\n      width: 100%;\n      position: relative; /* to avoid to be part of clickable zone*/\n      z-index: 2; /* to avoid to be part of clickable zone*/\n      float: unset;\n      flex-direction: ", ";\n\n      > .stx-ProductActions-BoxWrapper {\n        width: 100%;\n      }\n\n      ", ";\n    "])), function (props) {
  cov_22agp4srev().f[2]++;
  cov_22agp4srev().s[3]++;
  return props.inline ? (cov_22agp4srev().b[1][0]++, 'row') : (cov_22agp4srev().b[1][1]++, 'column');
}, _utils.gMediaQueries.sm(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n        flex-direction: row;\n        justify-content: flex-end;\n        float: right;\n\n        > .stx-ProductActions-BoxWrapper {\n          width: auto;\n        }\n      "])))))));
var ActionButton = (cov_22agp4srev().s[4]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_button.default), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _constants.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    height: 100%;\n    align-self: flex-end;\n    float: right;\n    margin: 0;\n    line-height: 17px;\n    padding: 0.7rem 1rem;\n    margin-bottom: 0.5rem;\n    min-width: 5rem;\n    background-color: ", ";\n    text-transform: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  "])), function (props) {
  cov_22agp4srev().f[3]++;
  cov_22agp4srev().s[5]++;
  return (0, _polished.lighten)(props.actionKey === 'book' ? (cov_22agp4srev().b[2][0]++, 0.1) : (cov_22agp4srev().b[2][1]++, 0), (0, _polished.desaturate)(props.actionKey === 'book' ? (cov_22agp4srev().b[3][0]++, 0.4) : (cov_22agp4srev().b[3][1]++, 0), (cov_22agp4srev().b[4][0]++, props.theme.button) && (cov_22agp4srev().b[4][1]++, props.theme.button.backgroundColor)));
}, function (props) {
  cov_22agp4srev().f[4]++;
  cov_22agp4srev().s[6]++;
  return (cov_22agp4srev().b[6][0]++, props.actionKey === 'watchNow') || (cov_22agp4srev().b[6][1]++, props.actionKey === 'reWatch') ? (cov_22agp4srev().b[5][0]++, 'uppercase') : (cov_22agp4srev().b[5][1]++, '');
}, function (props) {
  cov_22agp4srev().f[5]++;
  cov_22agp4srev().s[7]++;
  return (0, _polished.desaturate)(props.actionKey === 'book' ? (cov_22agp4srev().b[7][0]++, 0.4) : (cov_22agp4srev().b[7][1]++, 0), (cov_22agp4srev().b[8][0]++, props.theme.button) && (cov_22agp4srev().b[8][1]++, props.theme.button.backgroundColor));
})), _constants.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    align-self: flex-end;\n    float: right;\n    margin: 0;\n    margin-bottom: 0.5rem;\n    min-width: 5rem;\n    font-size: ", ";\n    line-height: ", ";\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight))));
var BoxWrapper = (cov_22agp4srev().s[8]++, _styledComponents.default.div.attrs({
  className: "stx-ProductActions-BoxWrapper"
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  align-self: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (props) {
  cov_22agp4srev().f[6]++;
  cov_22agp4srev().s[9]++;
  return props.inline ? (cov_22agp4srev().b[9][0]++, 'flex-end') : (cov_22agp4srev().b[9][1]++, 'auto');
}, function (props) {
  cov_22agp4srev().f[7]++;
  cov_22agp4srev().s[10]++;
  return props.inline ? (cov_22agp4srev().b[10][0]++, '8px') : (cov_22agp4srev().b[10][1]++, '0px');
}, function (props) {
  cov_22agp4srev().f[8]++;
  cov_22agp4srev().s[11]++;
  return props.inline ? (cov_22agp4srev().b[11][0]++, '8px') : (cov_22agp4srev().b[11][1]++, '0px');
}, function (props) {
  cov_22agp4srev().f[9]++;
  cov_22agp4srev().s[12]++;
  return props.inline ? (cov_22agp4srev().b[12][0]++, '8px') : (cov_22agp4srev().b[12][1]++, '0px');
}));
var NoteWrapper = (cov_22agp4srev().s[13]++, _styledComponents.default.div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  width: 100%;\n  text-align: center;\n  font-size: 85%;\n"])), function (props) {
  cov_22agp4srev().f[10]++;
  cov_22agp4srev().s[14]++;
  return props.color;
}));

/*
 * Component to display the buttons linked to the action of a product
 */
function ProductActions(_ref2) {
  var _this = this;
  var product = _ref2.product,
    performance = _ref2.performance,
    timeslot = _ref2.timeslot,
    actions = _ref2.actions,
    inline = _ref2.inline,
    onActionClick = _ref2.onActionClick,
    buttonNote = _ref2.buttonNote,
    ecommerceGoogleTracking = _ref2.ecommerceGoogleTracking,
    accessibilityDescribeAction = _ref2.accessibilityDescribeAction,
    accessibilityActionLabel = _ref2.accessibilityActionLabel,
    intl = _ref2.intl,
    themeQueries = _ref2.themeQueries,
    buttonVariant = _ref2.buttonVariant,
    currentTheme = _ref2.currentTheme;
  cov_22agp4srev().f[11]++;
  var props = (cov_22agp4srev().s[15]++, {
    onActionClick: onActionClick,
    product: product,
    performance: performance,
    ecommerceGoogleTracking: ecommerceGoogleTracking
  });
  // Get the actions, first if explicetely passed, then from performance or timeslot and finally from the product.
  var curActions = (cov_22agp4srev().s[16]++, (cov_22agp4srev().b[13][0]++, actions) || (cov_22agp4srev().b[13][1]++, performance) && (cov_22agp4srev().b[13][2]++, performance.action) || (cov_22agp4srev().b[13][3]++, timeslot) && (cov_22agp4srev().b[13][4]++, timeslot.action) || (cov_22agp4srev().b[13][5]++, product) && (cov_22agp4srev().b[13][6]++, product.action));
  cov_22agp4srev().s[17]++;
  var getFormattedAction = function getFormattedAction(key) {
    cov_22agp4srev().f[12]++;
    cov_22agp4srev().s[18]++;
    return intl.formatMessage({
      id: "gravity.Product.".concat(key)
    });
  };
  cov_22agp4srev().s[19]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    themeQueries: themeQueries,
    currentTheme: currentTheme,
    productId: product.id,
    inline: inline,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 5
    }
  }, (0, _keys.default)(curActions).map(function (key) {
    cov_22agp4srev().f[13]++;
    cov_22agp4srev().s[20]++;
    return (cov_22agp4srev().b[14][0]++, curActions[key]) && (cov_22agp4srev().b[14][1]++, /*#__PURE__*/_react.default.createElement(BoxWrapper, {
      key: key,
      inline: inline,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 165,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react.default.createElement(ActionButton, (0, _extends2.default)({
      variant: (cov_22agp4srev().b[16][0]++, currentTheme === _constants.TicketShopTheme.EVOLUTION) && (cov_22agp4srev().b[16][1]++, key !== 'buy') ? (cov_22agp4srev().b[15][0]++, _button.ButtonVariant.secondary) : (cov_22agp4srev().b[15][1]++, buttonVariant),
      small: currentTheme === _constants.TicketShopTheme.EVOLUTION
    }, _ProductHelper.default.getActionHandler(props, product.id, curActions[key]), {
      actionKey: key,
      "aria-describedby": accessibilityDescribeAction,
      "aria-label": accessibilityActionLabel ? (cov_22agp4srev().b[17][0]++, "".concat(getFormattedAction(key), " ").concat(accessibilityActionLabel)) : (cov_22agp4srev().b[17][1]++, ''),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 166,
        columnNumber: 15
      }
    }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
      id: "gravity.Product.".concat(key),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 177,
        columnNumber: 17
      }
    }))));
  }), (cov_22agp4srev().b[18][0]++, buttonNote) && (cov_22agp4srev().b[18][1]++, /*#__PURE__*/_react.default.createElement(NoteWrapper, {
    color: '#4384ED',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 182,
      columnNumber: 22
    }
  }, buttonNote)));
}
cov_22agp4srev().s[21]++;
ProductActions.propTypes = {
  /* The product object to display */
  product: _product.ProductType.isRequired,
  /* A specific performance to display, if provided take the performance data in priority */
  performance: _product.PerformanceType,
  /* a specific timeslot to display, if provided take the timeslotData in priority */
  timeslot: _product.TimeslotType,
  /* The actions defined */
  actions: _propTypes.default.objectOf(_propTypes.default.string),
  /** list action button in one line or not */
  inline: _propTypes.default.bool,
  /** Custom handler for action */
  onActionClick: _propTypes.default.func,
  /** Option to use google enhance tracking to push data to data layer */
  ecommerceGoogleTracking: _propTypes.default.shape({}),
  buttonNote: _propTypes.default.string,
  /** Label to describe action button */
  accessibilityDescribeAction: _propTypes.default.string,
  /** Label of action button for screen reader to read */
  accessibilityActionLabel: _propTypes.default.string,
  intl: _reactIntl.intlShape.isRequired,
  themeQueries: _utils.WithThemeQueriesType,
  buttonVariant: _button.ButtonVariantType,
  currentTheme: _propTypes.default.string.isRequired
};
cov_22agp4srev().s[22]++;
ProductActions.defaultProps = {
  actions: undefined,
  performance: undefined,
  timeslot: undefined,
  inline: false,
  onActionClick: null,
  buttonNote: null,
  ecommerceGoogleTracking: {
    useGoogleEnhancedTracking: false,
    user: {}
  },
  accessibilityDescribeAction: null,
  accessibilityActionLabel: null,
  themeQueries: {},
  buttonVariant: _button.ButtonVariant.primary
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(ProductActions)));